import { Flex } from 'shared/ui/flex';
import { FC, Fragment } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { toCancelBooking, toWaitingList, useOrderInfo } from 'entities/orders';
import { ButtonContainer, Padding } from '../styles';
import { OrderDetailButtonsProps } from '../types';
import { OrderDetailCancelConfirm } from './orderDetailCancelConfirm';
import { ModalProvider } from 'shared/ui/modal';
import { OrderDetailMainButton } from './orderDetailMainButton';
import { useLocation } from 'react-router-dom';
import { OrderDetailWaitingConfirm } from './orderDetailWaitingConfirm';
import { OrderDetailRemoveConfirm } from './orderDetailRemoveConfirm';
import { OrderRestoreButtons } from './orderRestoreButtons';
import { getOrdersByDate, getOrdersNext } from 'entities/orders/model/ordersThunk';
import { isToday } from 'date-fns';
import { selectSelectedTimeslot, selectTimeslots, useTimeslotZone } from 'entities/toolbar/timeslots';

export const OrderDetailButtons: FC<OrderDetailButtonsProps> = props => {
	const dispatch = useAppDispatch();
	const { selectedId, close } = useOrderInfo();
	const { pathname } = useLocation();
	const timeslots = useAppSelector(selectTimeslots);
	const selectedTimeslot = useAppSelector(selectSelectedTimeslot);
	const { formatISODateBySlotZone } = useTimeslotZone();

	const { order, fetchData } = props;

	const dispatchToWaitingList = async () => {
		return await dispatch(toWaitingList({ id: selectedId }));
	};

	const cancelBook = async () => {
		return await dispatch(toCancelBooking({ id: selectedId }));
	};

	const onCancelSuccessAction = () => {
		fetchData?.();
		if (selectedTimeslot && !isToday(selectedTimeslot) && !isToday(timeslots[0]?.dt_start)) {
			const dateStart = new Date(selectedTimeslot);
			dateStart.setHours(0, 0, 0, 0);
			const dateEnd = new Date(selectedTimeslot);
			dateEnd.setHours(23, 59, 59, 59);

			dispatch(getOrdersByDate({
				dt_start__gte: formatISODateBySlotZone(dateStart),
				dt_start__lte: formatISODateBySlotZone(dateEnd),
				status: 'appointed'
			}))
		} else {
			dispatch(getOrdersNext({}));
		}

	}

	const fetchAfterAction = () => {
		dispatch(getOrdersNext({}));
		if (pathname !== '/') {
			fetchData?.();
		}
	};

	return (
		<Fragment>
			{order && (
				<Padding>
					<ButtonContainer>
						<OrderDetailMainButton {...props} />
					</ButtonContainer>
          {!props.hideRestore && 
					<OrderRestoreButtons
						orderId={order.id}
						order={order}
						status={order.status}
						dateEnd={order.appointment?.dt_visit_end}
					/>
          }
					{order.status === 'appointed' && (
						<Flex $justify="space-between">
							<ModalProvider>
								<OrderDetailCancelConfirm
									cancelBook={cancelBook}
									onSuccessFetchData={onCancelSuccessAction}
									order={order}
								/>
							</ModalProvider>

							<ModalProvider>
								<OrderDetailWaitingConfirm
									dispatchToWaitingList={
										dispatchToWaitingList
									}
									onSuccessFetchData={fetchAfterAction}
									person={order?.person}
									onClose={close}
								/>
							</ModalProvider>
						</Flex>
					)}
					{order.status === 'waiting_list' && (
						<ModalProvider>
							<OrderDetailRemoveConfirm
								removeFromWaitingList={cancelBook}
								onSuccessFetchData={fetchAfterAction}
								person={order?.person}
							/>
						</ModalProvider>
					)}
				</Padding>
			)}
		</Fragment>
	);
};
